import { Component } from '@angular/core';
import { EnvironmentService } from '../../core/enviroment/environment.service';

@Component({
  selector: 'app-error-token',
  templateUrl: './error-token.component.html',
  styleUrls: ['../errors-pages.component.scss']
})
export class ErrorTokenComponent {

  constructor(private envService: EnvironmentService) { }

  get portalUrl(): string {
    return this.envService.getEnvVar('base_url_portal');
  }
}
